import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import ListingLibResolvedCell from 'framework-listing-lib/table/ListingLibResolvedCell';
import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
//@ts-expect-error Missing types
import { BUSINESS_UNIT_DROPDOWN_OPTION } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { PROPERTIES } from '../constants';
import { FormType } from '../types';
import UnavailableNonHubSpotData from '../UnavailableNonHubSpotData';
import UnavailableBusinessUnitData from '../UnavailableBusinessUnitData';
import { jsx as _jsx } from "react/jsx-runtime";
const INITIAL_WIDTH = 140;
function BUCell({
  crmObject,
  tdProps: {
    width
  }
}) {
  const propertyValue = getPropertyValue(crmObject, PROPERTIES.BUSINESS_UNIT_IDS);
  const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
  if (formType === FormType.CAPTURED) return /*#__PURE__*/_jsx(UnavailableNonHubSpotData, {});
  const CustomCell = ({
    value
  }) => {
    if (!value) return /*#__PURE__*/_jsx(UnavailableBusinessUnitData, {});
    const truncateLength = width || INITIAL_WIDTH;
    return /*#__PURE__*/_jsx(BusinessUnitTag, {
      buId: value.id,
      buOptions: [value],
      noBorder: true,
      truncateLength: truncateLength
    });
  };
  return /*#__PURE__*/_jsx(ListingLibResolvedCell, {
    CustomCell: CustomCell,
    id: propertyValue,
    objectType: BUSINESS_UNIT_DROPDOWN_OPTION
  });
}
export const businessUnitId = {
  width: 175,
  renderCell: props => /*#__PURE__*/_jsx(BUCell, Object.assign({}, props))
};